var render = function render(){var _vm=this,_c=_vm._self._c;return (new RegExp(_vm.highLightStr).test(_vm.text))?_c('span',[_vm._v(" "+_vm._s(_vm.text.substr(0, _vm.text.indexOf(_vm.highLightStr)))),_c('span',{style:({color: _vm.color})},[_vm._v(_vm._s(_vm.highLightStr))]),_vm._v(_vm._s(_vm.text.substr(_vm.text.indexOf(_vm.highLightStr) + _vm.highLightStr.length))+" ")]):_c('span',[_vm._v(_vm._s(_vm.text))])
}
var staticRenderFns = []

export { render, staticRenderFns }